import React, { createContext, useState, useEffect } from "react";
import Cookies from 'js-cookie';
const context = createContext(null);

const UserProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [member, setMember] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
      setLoading(true)
      var user_data_cookie = Cookies.get('user_data')
      if (user_data_cookie){
        var user_data = JSON.parse(atob(user_data_cookie));
        setUser(user_data)
        fetch(`${process.env.REACT_APP_API_URL}/basic-info/`, {
          headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
          credentials: 'include',
          method: 'GET',
        })
        .then(function (response) {
          if(response.status === 200){
            response.json().then(function(data){
              setMember(data)
              setLoading(false) 
            })
          }
          else{
            console.log('Internal Server Error');
            setLoading(false) 
          }
        })     
        .catch(err => {
            console.log('Internal Server Error');
            setLoading(false) 
        });
    } else {
      setLoading(false) 
    }
  }, []);

  return (
      <context.Provider value={{setUser, user, loading, setMember, member}}>
          {children}
      </context.Provider>
  );
};

UserProvider.context = context;

export default UserProvider;
